import React from 'react';

export default function MoodNeutralIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-mood-neutral"><circle cx="12" cy="12" r="10" className="primary"/><path className="secondary" d="M8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2zm.5-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm7 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>
    </Tag>
  )
};
